import styled from 'styled-components'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles'

type LeadFormWrapperProps = {
  colorScheme?: string
  withBackground?: boolean
}

export const LeadFormWrapper = styled.div<LeadFormWrapperProps>`
  width: 100%;
  background-color: ${({ theme, colorScheme, withBackground }) =>
    withBackground ? theme.colorScheme[`${colorScheme}`].surface.outside : 'transparent'};
  padding: ${({ theme }) => theme.rem(32, 0)};

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }
`

export const LeadFormStepTitleWrapper = styled.div<LeadFormWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(24)};
  margin-bottom: ${({ theme }) => theme.rem(48)};
  width: 100%;

  ${({ theme }) => theme.mediaQuery.lg(`
    width: ${theme.rem(650)};
  `)};
`

export const FieldWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.rem(24)};
`

export const ErrorMessage = styled.div`
  ${Paragraph} {
    padding-top: ${({ theme }) => theme.rem(16)};
    color: ${({ theme }) => theme.palette.red['50']};
  }
`

export const SuccessMessage = styled.div`
  padding-top: ${({ theme }) => theme.rem(24)};
  width: 100%;

  ${({ theme }) => theme.mediaQuery.lg(`
    width: ${theme.rem(650)};
  `)};

  .green {
    color: ${({ theme }) => theme.palette.greenHill['400']};
  }
`
